// import { useState } from "react";
// import axios from "axios";

// const AddAgent = () => {
//    const [name, setName] = useState("");
//    const [telecmiId, setTelecmiId] = useState("");

//    const handleSubmit = async () => {
//       try {
//          await axios.post("http://localhost:5000/api/agents", {
//             name,
//             telecmi_user_id: telecmiId
//          });

//          alert("Agent added");
//          setName("");
//          setTelecmiId("");

//       } catch (err) {
//          console.error(err);
//       }
//    };

//    return (
//       <div style={{ marginBottom: 20 }}>
//          <input
//             placeholder="Agent Name"
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//          />

//          <input
//             placeholder="TeleCMI ID (5004_33337658)"
//             value={telecmiId}
//             onChange={(e) => setTelecmiId(e.target.value)}
//          />

//          <button onClick={handleSubmit}>Add Agent</button>
//       </div>
//    );
// };

// export default AddAgent;

import { useEffect, useState } from "react";
import {
   Table,
   Button,
   Input,
   Space,
   message,
   Popconfirm,
   Card,
   Row,
   Col,
   Typography,
   Modal,
   Form,
   Statistic,
   Tag,
   Avatar,
   Tooltip,
} from "antd";
import {
   UserOutlined,
   UserAddOutlined,
   SearchOutlined,
   EditOutlined,
   DeleteOutlined,
   IdcardOutlined,
   TeamOutlined,
   ReloadOutlined,
} from "@ant-design/icons";

import {
   getAgents,
   addAgent,
   updateAgent,
   deleteAgent,
} from "../../services/agentService";

const { Title, Text } = Typography;

const AddAgent = () => {
   const [agents, setAgents] = useState([]);
   const [loading, setLoading] = useState(false);
   const [search, setSearch] = useState("");

   const [isModalOpen, setIsModalOpen] = useState(false);
   const [editing, setEditing] = useState(null);
   const [submitLoading, setSubmitLoading] = useState(false);

   const [form] = Form.useForm();

   useEffect(() => {
      fetchAgents();
   }, [search]);

   const fetchAgents = async () => {
      try {
         setLoading(true);
         const res = await getAgents({ search });
         setAgents(res.data);
      } catch (err) {
         console.error(err);
      } finally {
         setLoading(false);
      }
   };

   const openAddModal = () => {
      setEditing(null);
      form.resetFields();
      setIsModalOpen(true);
   };

   const openEditModal = (record) => {
      setEditing(record);
      form.setFieldsValue({
         name: record.name,
         telecmi_user_id: record.telecmi_user_id,
      });
      setIsModalOpen(true);
   };

   const closeModal = () => {
      setIsModalOpen(false);
      setEditing(null);
      form.resetFields();
   };

   const handleSubmit = async (values) => {
      try {
         setSubmitLoading(true);

         if (editing) {
            await updateAgent(editing.id, values);
            message.success("Agent updated successfully! ✅");
         } else {
            await addAgent(values);
            message.success("Agent added successfully! ✅");
         }

         closeModal();
         fetchAgents();

      } catch (err) {
         message.error("Something went wrong");
      } finally {
         setSubmitLoading(false);
      }
   };

   const handleDelete = async (id) => {
      try {
         await deleteAgent(id);
         message.success("Agent deleted");
         fetchAgents();
      } catch {
         message.error("Error deleting agent");
      }
   };

   const columns = [
      {
         title: "Agent",
         key: "agent",
         render: (_, record) => (
            <Space>
               <Avatar
                  style={{ backgroundColor: "#1890ff" }}
                  icon={<UserOutlined />}
               />
               <div>
                  <Text strong>{record.name}</Text>
                  <br />
               </div>
            </Space>
         ),
      },
      {
         title: "TeleCMI User ID",
         dataIndex: "telecmi_user_id",
         key: "telecmi_user_id",
         render: (id) => (
            <Tag color="blue" icon={<IdcardOutlined />}>
               {id}
            </Tag>
         ),
      },
      {
         title: "Actions",
         key: "actions",
         align: "center",
         render: (_, record) => (
            <Space>
               <Tooltip title="Edit Agent">
                  <Button
                     type="primary"
                     ghost
                     icon={<EditOutlined />}
                     onClick={() => openEditModal(record)}
                  />
               </Tooltip>

               <Popconfirm
                  title="Delete Agent"
                  description="Are you sure you want to delete this agent?"
                  onConfirm={() => handleDelete(record.id)}
                  okText="Yes"
                  cancelText="No"
                  okButtonProps={{ danger: true }}
               >
                  <Tooltip title="Delete Agent">
                     <Button danger icon={<DeleteOutlined />} />
                  </Tooltip>
               </Popconfirm>
            </Space>
         ),
      },
   ];

   return (
      <div style={{ padding: 24, minHeight: "100vh" }}>
         {/* Header */}
         <Card style={{ marginBottom: 10}}>
            <Row justify="space-between" align="middle">
               <Col>
                  <Title level={4} style={{ margin: 0 }}>
                     <TeamOutlined style={{ marginRight: 10, color: "#1890ff" }} />
                     Agents Management
                  </Title>
               </Col>
            </Row>
         </Card>

         {/* Stats Cards - FIXED: valueStyle → styles.content */}
         <Row gutter={[16, 16]} style={{ marginBottom: 10 }}>
            <Col xs={24} sm={8}>
               <Card hoverable size="small">
                  <Statistic
                     title="Total Agents"
                     value={agents.length}
                     prefix={<TeamOutlined />}
                     styles={{ content: { color: "#1890ff"} }}
                  />
               </Card>
            </Col>

            <Col xs={24} sm={12} md={8}>
               <Input
                  placeholder="Search agents..."
                  prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  allowClear
                  size="large"
               />
            </Col>
            <Col>
               <Button
                  type="primary"
                  icon={<UserAddOutlined />}
                  size="large"
                  onClick={openAddModal}
               >
                  Add Agent
               </Button>
            </Col>


         </Row>

         {/* Search & Add Button */}
         {/* <Card style={{ marginBottom: 24 }}>
            <Row justify="space-between" align="middle" gutter={[16, 16]}>
               <Col xs={24} sm={12} md={8}>
                  <Input
                     placeholder="Search agents..."
                     prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
                     value={search}
                     onChange={(e) => setSearch(e.target.value)}
                     allowClear
                     size="large"
                  />
               </Col>
               <Col>
                  <Button
                     type="primary"
                     icon={<UserAddOutlined />}
                     size="large"
                     onClick={openAddModal}
                  >
                     Add Agent
                  </Button>
               </Col>
            </Row>
         </Card> */}

         {/* Agents Table */}
         <Card>
            <Table
               dataSource={agents}
               size="small"
               columns={columns}
               rowKey="id"
               loading={loading}
               pagination={{
                  pageSize: 10,
                  showSizeChanger: true,
                  showTotal: (total) => `Total ${total} agents`,
               }}
            />
         </Card>

         {/* Add/Edit Modal - FIXED: destroyOnClose → destroyOnHidden */}
         <Modal
            title={
               <Space>
                  {editing ? <EditOutlined /> : <UserAddOutlined />}
                  <span>{editing ? "Edit Agent" : "Add New Agent"}</span>
               </Space>
            }
            open={isModalOpen}
            onCancel={closeModal}
            footer={null}
            destroyOnHidden
         >
            <Form
               form={form}
               layout="vertical"
               onFinish={handleSubmit}
               style={{ marginTop: 20 }}
            >
               <Form.Item
                  name="name"
                  label="Agent Name"
                  rules={[
                     { required: true, message: "Please enter agent name" },
                  ]}
               >
                  <Input
                     prefix={<UserOutlined style={{ color: "#bfbfbf" }} />}
                     placeholder="Enter agent name"
                     size="large"
                  />
               </Form.Item>

               <Form.Item
                  name="telecmi_user_id"
                  label="TeleCMI User ID"
                  rules={[
                     { required: true, message: "Please enter TeleCMI ID" },
                  ]}
               >
                  <Input
                     prefix={<IdcardOutlined style={{ color: "#bfbfbf" }} />}
                     placeholder="e.g. 5004_33337658"
                     size="large"
                  />
               </Form.Item>

               <Form.Item style={{ marginBottom: 0, marginTop: 24 }}>
                  <Space style={{ width: "100%", justifyContent: "flex-end" }}>
                     <Button onClick={closeModal}>Cancel</Button>
                     <Button
                        type="primary"
                        htmlType="submit"
                        loading={submitLoading}
                        icon={editing ? <EditOutlined /> : <UserAddOutlined />}
                     >
                        {editing ? "Update Agent" : "Add Agent"}
                     </Button>
                  </Space>
               </Form.Item>
            </Form>
         </Modal>
      </div>
   );
};

export default AddAgent;